import apiClient, { eiraApiClient } from '../config/axios';

export interface PrescriptionListItem {
  id: string;
  prescriptionId: string;
  createdAt: string;
  prescriptionDate: string;
  status: string;
  doctorName: string;
  caseId: string;
  patientId: string;
}

export interface PrescriptionListResponse {
  prescriptions: PrescriptionListItem[];
  totalCount: number;
  hasPrescriptions: boolean;
}

export interface PrescriptionDetails {
  patientId: string;
  hasPrescription: boolean;
  prescriptionData: any;
  doctorDetails: any;
  prescriptionDetails: any;
  appointmentDetails: any;
  latestPrescriptionId: string | null;
}

export interface PrescriptionResponse {
  success: boolean;
  data: PrescriptionDetails;
  message: string;
}

class PrescriptionService {
  /**
   * Get prescription list for a patient (sorted by creation date)
   */
  static async getPatientPrescriptions(patientId: string): Promise<{ success: boolean; data: PrescriptionListResponse; message: string }> {
    try {
      const response = await apiClient.get(`/patients/${patientId}/prescriptions`);
      return response.data;
    } catch (error: any) {
      console.error('Error fetching prescription list:', error.message);
      throw new Error(`Failed to fetch prescription list: ${error.message}`);
    }
  }

  /**
   * Get the latest prescription details for a patient
   */
  static async getLatestPrescription(patientId: string): Promise<PrescriptionResponse> {
    try {
      const response = await apiClient.get(`/patients/${patientId}/latest-prescription`);
      return response.data;
    } catch (error: any) {
      console.error('Error fetching latest prescription:', error.message);
      throw new Error(`Failed to fetch prescription: ${error.message}`);
    }
  }

  /**
   * Get prescription details by prescription ID
   */
  static async getPrescriptionDetails(userId: string, prescriptionId: string): Promise<any> {
    try {
      // Use absolute URL to bypass base URL configuration
      const response = await eiraApiClient.get('/prescription/details', {
        params: {
          user_id: userId,
          client: 'dxAiPatientClinic',
          prescriptionId: prescriptionId
        }
      });
      return response.data;
    } catch (error: any) {
      console.error('Error fetching prescription details:', error.message);
      throw new Error(`Failed to fetch prescription details: ${error.message}`);
    }
  }
}

export default PrescriptionService;
